import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import DocRenderer from './DocRenderer';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { Navbar } from './Navbar.jsx';

function FilesPrev() {
  const navigate  = useNavigate();
  const location  = useLocation();
  const { data, resumeFile, jobDescriptionFile, jobDescriptionText } = location.state || {};

  const [screenWidth,  setScreenWidth]  = useState(window.innerWidth);
  const [screenHeight, setScreenHeight] = useState(window.innerHeight);

  useEffect(() => {
    const onResize = () => { setScreenWidth(window.innerWidth); setScreenHeight(window.innerHeight); };
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const handleContinue = () => {
    const steps = JSON.parse(localStorage.getItem('completedSteps') || '[]');
    if (!steps.includes('filesPreview')) { steps.push('filesPreview'); localStorage.setItem('completedSteps', JSON.stringify(steps)); }
    navigate('/partScore', { state: { data, jobDescriptionFile, jobDescriptionText, resumeFile } });
  };

  const handleReupload = (target) => {
    // target: 'resume' or 'jd'
    navigate('/upload', { state: { reupload: target } });
  };

  return (
    <>
      <Navbar />
      <div className="flex flex-col bg-white min-h-screen p-4 md:p-8">

        {/* Top action row */}
        <div className="flex flex-wrap justify-between items-center mt-4 gap-3">
          <button
            onClick={() => navigate('/upload')}
            className="px-5 py-2 rounded-lg bg-gray-100 text-gray-700 text-sm font-medium hover:bg-gray-200 transition"
          >
            ← Back
          </button>

          <button
            onClick={handleContinue}
            className="px-5 py-2 rounded-lg bg-blue-600 text-white text-sm font-semibold hover:bg-blue-500 transition"
          >
            View Analysis →
          </button>
        </div>

        {/* Document previews */}
        <div className="flex flex-col lg:flex-row justify-center items-start gap-8 mt-8">
          {/* Resume */}
          <div className="flex flex-col items-center lg:w-1/2 w-full">
            <div className="flex justify-between items-center w-full mb-3">
              <h6 className="text-gray-800 font-semibold text-xl">Your Resume</h6>
              <button
                onClick={() => handleReupload('resume')}
                className="text-xs px-3 py-1.5 rounded-lg bg-gray-100 text-gray-500 hover:bg-gray-200 transition"
              >
                Re-upload ↑
              </button>
            </div>
            <div className="w-full bg-white shadow-lg overflow-y-auto overflow-x-hidden rounded-xl border border-gray-100 max-h-[70vh]">
              {resumeFile
                ? <DocRenderer file={resumeFile} key={`${screenWidth}-${screenHeight}`} />
                : <div className="p-8 text-center text-gray-400">No resume uploaded.</div>}
            </div>
          </div>

          {/* Job Description */}
          <div className="flex flex-col items-center lg:w-1/2 w-full">
            <div className="flex justify-between items-center w-full mb-3">
              <h6 className="text-gray-800 font-semibold text-xl">Job Description</h6>
              <button
                onClick={() => handleReupload('jd')}
                className="text-xs px-3 py-1.5 rounded-lg bg-gray-100 text-gray-500 hover:bg-gray-200 transition"
              >
                Re-upload ↑
              </button>
            </div>
            <div className="w-full bg-white shadow-lg overflow-y-auto overflow-x-hidden rounded-xl border border-gray-100 max-h-[70vh]">
              {jobDescriptionFile
                ? <DocRenderer file={jobDescriptionFile} key={`${screenWidth}-${screenHeight}`} />
                : jobDescriptionText
                ? <div className="p-6 text-gray-700 whitespace-pre-wrap text-sm leading-relaxed">{jobDescriptionText}</div>
                : <div className="p-8 text-center text-gray-400">No job description uploaded.</div>}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FilesPrev;
